



































































import {Component, Vue, Watch} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {
  IpModuleInterface,
  PModule,
  PModuleTableHeader,
  PModuleWithMeasurements,
} from './interfaces';
import {PMProcessActionType, PMProcessStatus} from './enums';
import pmoduleTasksModule from '@/store/modules/entities/pmodules/pmoduleTasksModule';
import {Can} from '@casl/vue';
import {TypeData} from '@/api/configurate';
import {PModuleType} from '@/enums/configs';
import {
  pmonitorTypes,
  pmoduleDeveloperInfoDataRoutesByTypeMap,
  pmoduleStoresByTypeMap,
} from '@v/system/modules/configurate';
import {httpClient} from '@/api/baseApi';
import axios from 'axios';
import MeasurementDialog from '@/components/MeasurementDialog.vue';
import {isNumber, isString} from '@/utils/commonUtils';

@Component({
  components: {
    TableRoute,
    Can,
    MeasurementDialog,
  },
})
export default class Monitors extends Vue {
  pmonitorTypes: IpModuleInterface[] = pmonitorTypes;

  get types(): TypeData[] {
    return this.pmonitorTypes.map(x => ({
      id: x.value.toString(),
      type: x.type as PModuleType,
      name: x.description,
      enabled: true,
    }));
  }

  statusesWS: WebSocket | null = null;

  modulesWS: WebSocket | null = null;

  // Строка поиска
  search = '';

  typeSearch: PModuleType | null = null;

  pmListCash: PModule[] = [];

  selectedPmModule!: PModuleWithMeasurements;

  nameOfModule!: string;

  fullListModelTypes: IpModuleInterface[] = [];

  fullHeaders: PModuleTableHeader[] = [
    {
      text: 'Наименование',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Тип',
      value: 'typeDescription',
      sortable: true,
    },
  ];

  headers = this.fullHeaders;

  canViewModulesOrSensors() {
    return 'modules_journal';
  }

  canEditModulesOrSensors() {
    return 'modules_journal';
  }

  getShortList(list: any) {
    return list;
  }

  filterList(data: PModule[]) {
    const list = data.map((item: any) => {
      const typeName: any = this.fullListModelTypes.find(
        (itemType: IpModuleInterface) => itemType.value === item.type,
      )?.type;

      return {
        ...item,
        typeName,
      };
    });

    return this.getShortList(list);
  }

  getSelectFilterList(data: any) {
    return this.getShortList(data);
  }

  get apiStore() {
    if (!this.pmListCash.length && pmoduleTasksModule.all && pmoduleTasksModule.all.length) {
      pmoduleTasksModule.all.forEach(x => {
        this.pmListCash.push(x);
      });
    }
    return pmoduleTasksModule;
  }

  get typesStoreMap() {
    return pmoduleStoresByTypeMap;
  }

  @Watch('pmListCash')
  onChangePmListCash(val: any) {
    const newList = this.filterList(val);
    pmoduleTasksModule.filterListAction(newList);
  }

  // Фильтруем журнал по наименованию при изменении контрола
  @Watch('search')
  onSearch(newVal: string) {
    this.pmFiltering(newVal, this.typeSearch);
  }

  @Watch('$route')
  async onChangeRoute() {
    this.search = '';
    this.typeSearch = null;
    const newList = this.filterList(this.pmListCash);

    pmoduleTasksModule.filterListAction(newList);

    await this.subscribeStatusesWS();
  }

  // Фильтруем журнал по типу при изменении контрола
  @Watch('typeSearch')
  onTypeSearch(newVal: string) {
    this.pmFiltering(this.search, newVal);
  }

  // метод при использовании двух фильтров одновременно
  pmFiltering(name: string, type: any) {
    const moduleStoreModule = this.pmListCash;

    let newList: PModule[] = [];

    if (!name) {
      newList = this.pmListCash;
    } else {
      newList = moduleStoreModule.filter((x: any) =>
        x.name
          .toLowerCase()
          .trim()
          .includes(name.toLowerCase().trim()),
      );
    }
    if (type) {
      newList = newList.filter((x: any) => x.type == type);
    }

    pmoduleTasksModule.filterListAction(this.filterList(newList));
  }

  isModuleActive(item: PModule) {
    return item.processStatus == PMProcessStatus.Active;
  }

  isModuleExecutable(item: PModule) {
    // TODO: костыль, сделать нормально, когда будет возможно!
    return [
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
    ].includes(item.type);
  }

  isModuleHasDeveloperInfo(item: PModule) {
    // TODO: костыль, сделать нормально, когда будет возможно!
    return [
      PModuleType.DtcpTahoModule,
      PModuleType.CrmModule,
      PModuleType.DtcpServerModule,
      PModuleType.DtcpAccelerometerModule,
      PModuleType.DtcpTemperatureModule,
      PModuleType.DtcpEnergyModule,
      PModuleType.HeaterMonitorModule,
      PModuleType.CleanStorageModule,
      PModuleType.ServerMonitorModule,
      PModuleType.BearingControlModule,
      PModuleType.PingerModule,
      PModuleType.DtcpEmulatorModule,
    ].includes(item.type);
  }

  async subscribeStatusesWS() {
    this.statusesWS = await pmoduleTasksModule.statusesChangesWSConnection();
    if (this.statusesWS) {
      this.statusesWS.onmessage = async (e: {data: string}) => {
        const parsedData = JSON.parse(e.data);
        await pmoduleTasksModule.updateStatuses({statusMap: parsedData});
      };
    }
    this.modulesWS = await pmoduleTasksModule.modulesChangesWSConnection();
    if (this.modulesWS) {
      this.modulesWS.onmessage = async (e: {data: string}) => {
        const parsedData = JSON.parse(e.data) as {_id: string; data: {status: string}};
        await pmoduleTasksModule.updateModules(parsedData);
      };
    }
  }

  async created() {
    const newList = this.filterList(this.pmListCash);
    pmoduleTasksModule.filterListAction(newList);

    await this.subscribeStatusesWS();
  }

  /*
    Переход на страницу показа данных
  *
  async showModuleView(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }

  isModuleHasView(item: any) {
    return pmoduleDataRoutesByTypeMap.has(item.type);
  }*/

  /*
    Перезапуск процесса ПМ
  */
  async restart(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Restart,
    });
  }

  /*
    Остановка процесса ПМ
  */
  async stop(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Stop,
    });
  }

  /*
    Запуск процесса ПМ
  */
  async start(item: any) {
    const module = this.typesStoreMap.get(item.type) as any;
    if (!module) return;
    await module.processAction({
      id: item.id,
      action: PMProcessActionType.Start,
    });
  }

  /*
    Переход на страницу показа данных
  */
  async showDeveloperModuleInfo(item: any) {
    const {href} = this.$router.resolve({
      name: pmoduleDeveloperInfoDataRoutesByTypeMap.get(item.type),
      params: {id: `${item.id}`},
    });
    window.open(href, '_blank');
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединение веб сокета
  async closeWS() {
    if (this.statusesWS) {
      this.statusesWS.close();
      this.statusesWS = null;
    }
    if (this.modulesWS) {
      this.modulesWS.close();
      this.modulesWS = null;
    }
  }

  get measurementDialog() {
    return this.$refs.measurementDialog as any;
  }

  module!: any;

  // событие, срабатывающее при нажатии на кнопку
  async changeBoundary(item: any) {
    // загружаем ПМ
    const mod = this.pmonitorTypes.filter((type: any) => type.value == item.type);
    const {data} = await httpClient.get(`${mod[0].url}/${item.id}`);
    this.selectedPmModule = data;
    this.nameOfModule = this.selectedPmModule.name;

    const newMeasForm: any = [];

    // так как запрос вернул нам поля с другими названиями (с _ ), меняем названия полей на новые
    const measurement = this.selectedPmModule?.measurements;
    if (measurement?.length) {
      measurement.forEach((meas: any) => {
        const modal: any = {
          measurementId: meas.module_type_measurement_id,
          measurementDescription: meas.module_type_measurement_description,
          topWarningBoundary: meas.top_warning_boundary,
          topDangerBoundary: meas.top_danger_boundary,
          topErrorBoundary: meas.top_error_boundary,
          bottomWarningBoundary: meas.bottom_warning_boundary,
          bottomDangerBoundary: meas.bottom_danger_boundary,
          bottomErrorBoundary: meas.bottom_error_boundary,
        };
        newMeasForm.push(modal);
      });
    }
    this.selectedPmModule.type = item.type;
    this.selectedPmModule.measurements = newMeasForm;

    this.module = this.selectedPmModule;

    const dialog = this.$refs.measurementDialog as any;
    const options = {
      saveCallback: async () => {
        dialog.$refs.form.reset();
        // TODO: переделать с получением data
        await this.saveMeasCallback();
        dialog.close();
      },
    };
    //TODO: CancelToken и axios должен быть в store
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const request = {
      data: {
        bottomDangerBoundary: 0,
        bottomErrorBoundary: 0,
        bottomWarningBoundary: 0,
        editableBoundaries: {},
        isActive: false,
        isNew: false,
        measurementDescription: '',
        measurementId: 0,
        parent: {},
        topDangerBoundary: 0,
        topErrorBoundary: 0,
        topWarningBoundary: 0,
      },
    };

    this.measurementDialog.openDialog(this.selectedPmModule, item.type, options, source, request);
  }

  setNumberValue(value: any) {
    if (isString(value)) {
      const num = Number(value);
      if (isNumber(num)) return num;
    }
    return value;
  }

  async saveMeasCallback() {
    try {
      this.module.measurements = this.module.measurements.filter((x: any) => x.isActive === true);
      this.module.measurements.forEach((meas: any) => {
        this.setNumberValue(meas.topWarningBoundary);
        this.setNumberValue(meas.topDangerBoundary);
        this.setNumberValue(meas.topErrorBoundary);
        this.setNumberValue(meas.bottomWarningBoundary);
        this.setNumberValue(meas.bottomDangerBoundary);
        this.setNumberValue(meas.bottomErrorBoundary);
      });
      if (!isString(this.module.id)) this.module.id = this.module.id.toString();
      this.module.name = this.nameOfModule;
      const store = this.typesStoreMap.get(this.module.type) as any;
      if (!store) return;
      store.save(this.module);
      this.$emit('change');
    } catch {
      throw new Error('Ошибка сохранения');
    }
  }
}
